import pushToDataLayer from "./pushToDataLayer";

const notificationsOptInDismissEvent = () => {
  pushToDataLayer({
    cta_click: {
      cta_reference: "saved_items_marketing_opt_in_dismiss"
    }
  });
};

export default notificationsOptInDismissEvent;
